<template>
	<div class="leftres">
		<div>
			<div :class=" showorhide ? 'inputtop' : 'inputtops' ">
				<div style="display: inline-block;" v-for="(item , index) of formdata" :key="index">
					<Commondropdownlist ref="U8saleiRef" :options="item.options" :minrigth="item.minrigth"
						:maxrigth="item.maxrigth" :minleft="item.minleft" :maxleft="item.maxleft"
						:lablewith="item.lablewith" :inputdata="item.inputdata" :title="item.title"
						:fontSize="item.fontSize" :color="item.color" :placeholder="item.placeholder"
						:types="item.types" :inputtype="item.inputtype" :width="item.width"></Commondropdownlist>
				</div>
				<div :class=" showorhide ? 'Btngroups' : 'Btngroup' ">
					<CommonBtngroup :show="showorhide" @showclick="showclick" @hide="hide" @select="select"
						@reset="reset"></CommonBtngroup>
				</div>
				<div style="height:10px;">
				</div>
			</div>
			<div class="TableBox"
				style="box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.1); margin-top: 10px; background-color: #FFFFFF;">
				<U8salesorderreporttable :tableData="tableData" :total="total" @Export="Export"
					@handleCurrentChange="handleCurrentChange" @handleSizeChange="handleSizeChange">
				</U8salesorderreporttable>
			</div>
		</div>
	</div>
</template>

<script>
	import Commondropdownlist from '../../../components/common-dropdownlist.vue'
	import CommonBtngroup from '../../../components/commongroup.vue'
	import Dialog from '../../../components/dialog.vue'
	import U8salesorderreporttable from './components/U8salesorderreporttable.vue'
	import utils from '../../../common/utils'
	import {
		U8ReportU8SOReportList,
		U8ReportU8SOReportExport,
		HelperU8AccId,
		HelperU9Status,
	} from '@/api/home'
	export default {
		components: {
			Commondropdownlist,
			CommonBtngroup,
			Dialog,
			U8salesorderreporttable
		},
		data() {
			return {
				total: 1,
				pageindex: 1,
				pageSize: 20,
				tableData: [],
				dialogVisibles: false,
				showorhide: true,
				formdata: [{
						inputdata: '',
						title: '账套号',
						fontSize: '14px',
						color: '#333333',
						placeholder: '请选择',
						types: '',
						inputtype: 'select',
						width: '220px',
						options: [

						]
					},
					{
						inputdata: '',
						title: '经销商',
						fontSize: '14px',
						color: '#333333',
						placeholder: '请输入',
						types: 'text',
						inputtype: 'input',
						width: '210px'
					},
					{
						inputdata: "",
						title: "订单日期",
						fontSize: "14px",
						color: "#333333",
						placeholder: "请输入",
						types: "",
						inputtype: "date",
						width: "140px",
					},
					{
						inputdata: '',
						title: '订单号',
						fontSize: '14px',
						color: '#333333',
						placeholder: '请输入',
						types: 'text',
						inputtype: 'input',
						width: '210px'
					},
					{
						inputdata: '',
						title: '产品',
						fontSize: '14px',
						color: '#333333',
						placeholder: '请输入',
						types: 'text',
						inputtype: 'input',
						width: '210px'
					},
					{
						inputdata: "",
						title: "制单日期",
						fontSize: "14px",
						color: "#333333",
						placeholder: "请输入",
						types: "",
						inputtype: "date",
						width: "140px",
						lablewith: '75px'
					},
					{
						inputdata: "",
						title: "发货日期",
						fontSize: "14px",
						color: "#333333",
						placeholder: "请输入",
						types: "",
						inputtype: "dateda",
						width: "140px",
						lablewith: '155px'
					},
					{
						inputdata: "",
						title: "出库日期",
						fontSize: "14px",
						color: "#333333",
						placeholder: "请输入",
						types: "",
						inputtype: "date",
						width: "140px",
						lablewith: '75px'
					},
					{
						inputdata: [],
						title: '状态',
						fontSize: '14px',
						color: '#333333',
						placeholder: '请选择',
						types: '',
						inputtype: 'selectMultiple',
						width: '210px',
						options: []
					},
				],
				from: {
					cAccId: "",
					cSOCode: "",
					customer: "",
					inventory: "",
					dDate1: "",
					dDate2: "",
					createTime1: "",
					createTime2: "",
					dispatchTime1: "",
					dispatchTime2: "",
					rdRecord32Time1: "",
					rdRecord32Time2: "",
					Status: "",
				}
			}
		},
		created() {
			this.$message.warning("请填写搜索条件！");
			this.HelperU8AccId()
			this.HelperU9Status()
		},
		mounted() {
			this.$refs.U8saleiRef[2].startTime = this.$utils.getFYearDate();
		},
		methods: {
			// 列表
			async u8ReportU8SOReportList() {
				const loading = this.$loading({
					lock: true,
					text: '正在加载列表...',
					spinner: 'el-icon-loading',
					background: 'rgba(255,255,255,0.3)'
				});

				let {
					data,
					code,
					message
				} = await U8ReportU8SOReportList({
					cAccId: this.from.cAccId || this.formdata[0].options[0].key,
					cSOCode: this.from.cSOCode,
					customer: this.from.customer,
					inventory: this.from.inventory,
					dDate1: this.from.dDate1,
					dDate2: this.from.dDate2,
					createTime1: this.from.createTime1,
					createTime2: this.from.createTime2,
					dispatchTime1: this.from.dispatchTime2,
					dispatchTime2: this.from.dispatchTime1,
					rdRecord32Time1: this.from.rdRecord32Time1,
					rdRecord32Time2: this.from.rdRecord32Time2,
					Status: this.from.Status,
					pageSize: this.pageSize,
					pageIndex: this.pageindex
				})
				console.log("ssss");
				if (code == 0) {
					this.total = data.Count
					this.tableData = data.data
				} else {
					this.$message({
						type: 'error',
						message: message
					})
				}
				loading.close();
			},
			// 导出
			async U8ReportU8SOReportExport() {
				const loading = this.$loading({
					lock: true,
					text: '正在导出...',
					spinner: 'el-icon-loading',
					background: 'rgba(255,255,255,0.3)'
				});
				let resexprot = await U8ReportU8SOReportExport({
					cAccId: this.from.cAccId || this.formdata[0].options[0].key,
					cSOCode: this.from.cSOCode,
					customer: this.from.customer,
					inventory: this.from.inventory,
					dDate1: this.from.dDate1,
					dDate2: this.from.dDate2,
					createTime1: this.from.createTime1,
					createTime2: this.from.createTime2,
					dispatchTime1: this.from.dispatchTime2,
					dispatchTime2: this.from.dispatchTime1,
					rdRecord32Time1: this.from.rdRecord32Time1,
					rdRecord32Time2: this.from.rdRecord32Time2,
					Status: this.from.Status,
					pageSize: this.pageSize,
					pageIndex: this.pageindex
				})
				if (resexprot) {
					let date = new Date()
					let str = `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}-${date.getTime()}`
					utils.downloadFile(resexprot, `U8_U9销售订单报表${str}`, "xlsx")
					loading.close();
				} else {
					// 返回json
					this.$message.warning('导出失败');
					loading.close();
				}
				loading.close()
			},
			// 导出
			Export() {
				this.U8ReportU8SOReportExport()
			},
			// 获取账套号下拉
			async HelperU8AccId() {
				let {
					code,
					data
				} = await HelperU8AccId({

				})
				if (code == 0) {
					try {
						this.formdata[0].options = []
						data.map((item, index) => {
							let obj = {
								key: item.Value,
								value: item.Text
							}
							this.formdata[0].options.push(obj)
						})
						this.$refs.U8saleiRef[0].modelvalue = this.formdata[0].options[0].key
						//this.u8ReportU8SOReportList()
					} catch (error) {}
				}
			},
			// 获取状态下拉
			async HelperU9Status() {
				let {
					code,
					data
				} = await HelperU9Status({})
				if (code == 0) {
					try {
						this.formdata[8].options = []
						data.map((item, index) => {
							let obj = {
								key: item.Value,
								value: item.Text
							}
							this.formdata[8].options.push(obj)
						})
					} catch (error) {}
				}
			},
			reset() {
				this.$refs.U8saleiRef.map((item, index) => {
					if (index == 2 || index == 5 || index == 6 || index == 7) {
						item.startTime = ''
						item.endTime = ''
					} else if (index == 0) {
						item.modelvalue = this.formdata[0].options[0].key
					} else if (index == 8) {
						item.modelvalue = []
					} else {
						item.modelvalue = ''
					}
				})
			},
			showclick() {
				this.showorhide = true
			},
			hide() {
				this.showorhide = false
			},
			//搜索
			select() {
				this.pageindex = 1
				try {
					this.from.cAccId = this.$refs.U8saleiRef[0].modelvalue
					this.from.cSOCode = this.$refs.U8saleiRef[3].modelvalue
					this.from.customer = this.$refs.U8saleiRef[1].modelvalue
					this.from.inventory = this.$refs.U8saleiRef[4].modelvalue
					this.from.dDate1 = this.$refs.U8saleiRef[2].startTime
					this.from.dDate2 = this.$refs.U8saleiRef[2].endTime
					this.from.createTime1 = this.$refs.U8saleiRef[5].startTime
					this.from.createTime2 = this.$refs.U8saleiRef[5].endTime
					this.from.dispatchTime1 = this.$refs.U8saleiRef[6].startTime
					this.from.dispatchTime2 = this.$refs.U8saleiRef[6].endTime
					this.from.rdRecord32Time1 = this.$refs.U8saleiRef[7].startTime
					this.from.rdRecord32Time2 = this.$refs.U8saleiRef[7].endTime
					if (this.$refs.U8saleiRef[8].modelvalue) {
						this.from.Status = this.$refs.U8saleiRef[8].modelvalue.join(',')
					} else {
						this.from.Status = ''
					}
					this.u8ReportU8SOReportList()
				} catch (error) {
					this.u8ReportU8SOReportList()
				}
			},
			handleCurrentChange(pageindex) {
				this.pageindex = pageindex
				this.u8ReportU8SOReportList()
			},
			handleSizeChange(paegSzie) {
				this.pageSize = paegSzie
				this.u8ReportU8SOReportList()
			},
		}
	}
</script>

<style lang="less" scoped>
	.inputtop {
		width: 980px;
		height: 100px;
		box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.1);
		background-color: #ffffff;
		padding-top: 15px;
		padding-bottom: 70px;
		transition: all .3s;
		overflow: hidden;
	}

	.inputtops {
		width: 980px;
		height: 0px;
		box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.1);
		background-color: #ffffff;
		padding-top: 9px;
		padding-bottom: 64px;
		overflow: hidden;
		position: relative;
		transition: all .3s;
	}

	.Btngroup {
		display: inline-block;
		float: right;
		margin-right: 10px;
		width: 300px;
		height: 50px;
		background-color: #ffffff;
		position: relative;
		bottom: 95px;
	}

	.Btngroups {
		display: inline-block;
		float: right;
		margin-top: 5px;
		margin-right: 0px;
	}
</style>